import { Center, Orientation } from "../../../types/OsMapPrint";
import { getInitialOsMapPrintStore } from "../store";
import { updateStore } from "./updateStore";

type ResetStoreOptions = {
  orientation: Orientation;
  center: Center;
  site_id: string | null;
};

export const resetStore = ({ orientation, center, site_id }: ResetStoreOptions) => {
  updateStore({
    ...getInitialOsMapPrintStore(),
    center,
    orientation,
    site_id,
  });
};
